import styled from '@emotion/styled';
import { Color, PrimaryButton } from '@liveoptics/react-ui';
import React from 'react';

const Form = styled.form`
  padding: 26px;
  color: ${Color.coolGray700};
  > p {
    font: 400 14px/22px Open Sans;
    margin: 0;
  }
`;

const FormActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: baseline;
  padding-top: 43px;
`;

const SkipOwnerForm = (props: { onCancel: () => void }) => {
  return (
    <Form>
      <p>Customer's email is unknown, please defer to account team.</p>
      <FormActions>
        <PrimaryButton clickFn={props.onCancel}>Close</PrimaryButton>
      </FormActions>
    </Form>
  );
};

export default SkipOwnerForm;
